import React, { useContext } from 'react';
import { Form, Typography, Space, Button } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import { ApplicationUIContext, Table } from '@yuhuinc/ui-library';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { SpaceFullWidth } from '../../common/Styles';

const translate = (key) =>
  getTranslatedString(`landlordPortal.applicationManagement.leaseOverview.${key}`);

const { Title } = Typography;

const PeopleActions = ({ disabled }) => {
  return (
    <Space size="middle">
      <Button type="link" icon={<EditOutlined />} onClick={() => {}} disabled={disabled} />
      <Button type="link" icon={<DeleteOutlined />} onClick={() => {}} disabled={disabled} />
    </Space>
  );
};

const PeopleTable = ({ fields, operations, disabled }) => {
  const form = Form.useFormInstance();

  const columns = [
    {
      title: translate('leaseDetails.people.name'),
      dataIndex: 'name',
      render(_, record) {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              return getFieldValue(['leaseholders', record.name, 'full_name']);
            }}
          </Form.Item>
        );
      },
    },
    {
      title: translate('leaseDetails.people.email'),
      dataIndex: 'email',
      render(_, record) {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              return getFieldValue(['leaseholders', record.name, 'email']);
            }}
          </Form.Item>
        );
      },
    },
    {
      title: translate('leaseDetails.people.userType'),
      dataIndex: 'userType',
      render(_, record) {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              const value = getFieldValue(['leaseholders', record.name, 'applicant_type']);
              return translate(`leaseholderTypes.${value}`);
            }}
          </Form.Item>
        );
      },
    },
    {
      key: 'actions',
      render(_, record) {
        return (
          <Form.Item shouldUpdate>
            {({ getFieldValue, setFields }) => {
              return (
                <PeopleActions
                  applicant={getFieldValue(['leaseholders', record.name])}
                  onUpdate={(value) => setFields([{ name: ['leaseholders', record.name], value }])}
                  onDelete={() => operations.remove(record.name)}
                  disabled={disabled}
                />
              );
            }}
          </Form.Item>
        );
      },
    },
  ];

  return (
    <Table
      size="small"
      hideActionAndSearch
      columns={columns}
      dataSource={fields}
      rowKey={(record) => {
        return (
          form.getFieldValue(['leaseholders', record.name, 'id']) ||
          form.getFieldValue(['leaseholders', record.name, 'email'])
        );
      }}
      pagination={false}
    />
  );
};

const People = ({ disabled }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <>
      <Title level={isMobile ? 4 : 5}>{translate('leaseDetails.people')}</Title>
      <Form.List name="leaseholders">
        {(fields, operations) => {
          return (
            <>
              <SpaceFullWidth direction="vertical" size="middle">
                <PeopleTable fields={fields} operations={operations} disabled={disabled} />
                <Space size="middle">
                  <Button htmlType="button" disabled={disabled}>
                    {translate('leaseDetails.people.addApplicant')}
                  </Button>
                  <Button htmlType="button" disabled={disabled}>
                    {translate('leaseDetails.people.changeLeadLeaseholder')}
                  </Button>
                </Space>
              </SpaceFullWidth>
            </>
          );
        }}
      </Form.List>
    </>
  );
};

export default People;
